<template>
  <b-card>
    <div>
      <Strong>Rider-Wise Performance Report</Strong>

      <b-row class="mt-4">
        <b-col >                    
          <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >OFD Report</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">RVP Report</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 3;" class="nav-link " :class="{'active' : isActiveTab(3)}">Average Report</a>
              </li>            

              <!-- <li class="nav-item">
                <a @click="activeTab = 4;" class="nav-link " :class="{'active' : isActiveTab(4)}">OFP Report</a>
              </li>             -->
            </ul>
          </div>                       
        </b-col>
      </b-row>

      <component :is="currentComponent" class="mt-3"></component>
    </div>
  </b-card>
</template>
  
<script>
import riderWiseOFDReport_KSA_new from './riderWiseOFDReport_KSA_new.vue';
import riderWiseOFPReport_KSA_new from './riderWiseOFPReport_KSA_new.vue';
import riderWiseRVPReport_KSA_new from './riderWiseRVPReport_KSA_new.vue';
import riderWiseAverageReport_KSA_new from './riderWiseAverageReport_KSA_new.vue';

  export default {
    components: {
      riderWiseOFDReport_KSA_new,
      riderWiseOFPReport_KSA_new,
      riderWiseRVPReport_KSA_new,
      riderWiseAverageReport_KSA_new
    },
    data: function(){
      return{
        activeTab: 1,
        name: 'riderWisePerformanceReport_KSA',
      }
    },
    computed: {
      currentComponent(){
        if(this.activeTab === 1)           
          return "riderWiseOFDReport_KSA_new";
        else if(this.activeTab === 2)
          return "riderWiseRVPReport_KSA_new";
        else if(this.activeTab === 3)
          return "riderWiseAverageReport_KSA_new";
        else
         return "riderWiseOFPReport_KSA_new";
      }
    },
    created: function(){
      this.isActiveTab(1);
    },
    methods:{
      isActiveTab(id)
      {
        return this.activeTab === id;
      }
    }
  };
</script>

<style>

</style>